import React from 'react';

/** Logo + optional slogan (login, register, payment). Landing passes showTagline={false}. */
export default function AuthLeftBranding({ showTagline = true, className = '' }) {
  return (
    <div className={`auth-left-branding ${className}`.trim()}>
      <div className="logo">
        <img
          src={window.getPublicUrl('/assets/images/Fam-Connec_Logo-Black 1.svg')}
          alt="FamConnect26"
        />
      </div>
      {showTagline ? <p className="auth-left-slogan">A Web App Created to Connect Family Members</p> : null}
    </div>
  );
}
